export const formatDateSec2String = function (seconds: number) {
    const date = new Date(seconds * 1000);

    return date.toLocaleDateString('ru-RU', {
        year: "numeric",
        month: "long",
        day: "numeric"
    });
};

export const isPhoneNumberOk = function (phone: string, allowCity: boolean = false, allowForeign: boolean = false): boolean {
    const phoneNumber = phone.replace(/[^0-9]/, '');

    if (allowForeign && phone.length === 11) {
        return true;
    }

    if (phoneNumber.length === 10 && (allowCity || phoneNumber.startsWith('9'))) {
        return true;
    } else if (phoneNumber.length === 11) {
        if (phoneNumber.startsWith('8') && (allowCity || phoneNumber[1] === '9')) {
            return true;
        }
        if (phoneNumber.startsWith('7') && (!allowCity && phoneNumber[1] !== '9')) {
            return false;
        }
        return true;
    }
    return false;
}